module.exports = __webpack_public_path__ + "media/img/testimonial/daniellim_csc-2c29456cfbda504c73e05fffc31fd1d5.png";